export default __webpack_public_path__ + "static/media/2.a69f72f9.svg";